import { object } from 'prop-types';
import React, { useEffect, useState } from 'react';
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import Loader from '../../../CbOSESkin/components/Loader/Loader';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom';
import { AdditionalInformation } from '../CsrSection/AdditionalInformation';
import AddShoppingListModal from '../PlpSection/AddShoppingListModal';
import { useDispatch, useSelector } from 'react-redux';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { Modal } from '../Modal/Modal';
import CbMobileLogOut from './CbMobileLogOut';
function OrderDetail(props) {
    // const [orderDetail, setOrderDetail] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [orderDetail, setOrderDetail, orderDetailRef] = useStateRef('')
    const [multipleItem, setMultipleItem, multipleItemRef] = useStateRef('')
    const [cartModal, setCartModal] = useState(false);
    const [cartUpdatedModalEmpty, setCartUpdatedModalEmpty] = useState(false);
    const [cartUpdatedModal, setCartUpdatedModal] = useState(false);
    const [orderItemId, setOrderItemId, orderItemIdRef] = useStateRef('');
    const [orderItemDetail, setOderItemDetail, orderItemDetailRef] = useStateRef('');
    const [orderIdState, setOrderIdState, orderIdStateRef] = useStateRef('');
    const [replaceUserId, setReplaceUserId, replaceUserIdRef] = useStateRef('');
    const [specialItems, setSpecialItems, specialItemsRef] = useStateRef('')
    const [livingItems, setLivingItems, livingItemsRef] = useStateRef('')
    const [nonLivingItems, setNonLivingItems, nonLivingItemsRef] = useStateRef('')
    const [errorMsg, setErrorMsg, errorMsgRef] = useStateRef('');
    const dispatch = useDispatch();

    const [orderDetailsForCSR, setOrderDetailsForCSR, orderDetailsForCSRRef] = useStateRef('');
    const [billingDetails, setBillingDetails, billingDetailsRef] = useStateRef('')
    const [shippingDetails, setShippingDetails, shippingDetailsRef] = useStateRef('');
    const [productDetails, setProductDetails, productDetailsRef] = useStateRef('');
    const [additionalInformation, setAdditionalInformation, additionalInformationRef] = useStateRef('');
    const [isCreditType, setIsCreditType, isCreditTypeRef] = useStateRef(false);
    const [showOrderDetail, setShowOrderDetail, showOrderDetailRef] = useStateRef(true);
    const [showSubmitOrderError, setShowSubmitOrderError, showSubmitOrderErrorRef] = useStateRef(false);
    const [isSubmittedOrder, setIsSubmittedOrder, isSubmittedOrderRef] = useStateRef(false);
    const [userIdParam, setUserIdParam, userIdParamRef] = useStateRef(null);
    const history = useHistory();
    const specialListItems = [];
    const livingListItems = [];
    const nonLivingListItems = [];

    const index = 0;
    const profile = useSelector(state => state.getProfileDetails.profileDetails)
    const [currentUrl, setCurrentUrl, currentUrlRef] = useStateRef('')
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    useEffect(() => {
        var url = history.location.pathname
        var splitedUri = url.split("/")
        splitedUri && splitedUri[1] && splitedUri[2] ? setCurrentUrl(splitedUri[1] + "/" + splitedUri[2]) : "";
        if (profile) {
            if (profile && profile.transient && currentUrlRef.current && currentUrlRef.current == "account/order-detail") {
                window.location.href = "/account/login?resume=prev"
            }
            
        }
    }, [profile])
    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in orderdetails page loader true");
        } else {
            console.log("log in orderdetails page loader false");
            setIsLoading(true);
            if (props.containerObject && props.templateName) {
                var searchParam = window.location.search
                let params = new URLSearchParams(searchParam)
                var orderId = params.get("orderId");
                var userId = params.get("userId");
                setUserIdParam(userId)
            } else {
                var orderId = props.orderId;
                var userId = props.userId;

            }
            setOrderIdState(orderId && orderId)
            setReplaceUserId(userId)
            const inputMap = { orderId: orderId, userId: userId }
            handleOrderDetails(orderId);
        }

    }, [])

    function handleOrderDetails() {
        var actionUrl;
        if (props.isCSR && props.isCSR === "true") {

            actionUrl = `/api/rest/cb/order/order-detail-csr/${orderIdStateRef.current}/${props.isOrderTempB2I}`
        } else {
            actionUrl = `/api/rest/cb/order/order-detail/${orderIdStateRef.current}/${replaceUserIdRef.current}`;
        }
        fetch(`${window.location.protocol}//${window.location.hostname}${actionUrl}`, {
            credentials: "include",
            method: "GET",
            headers: new Headers({
                "content-Type": "application/json",
            })
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    if (props.isCSR) {

                        setOrderDetailsForCSR(JSON.parse(res.response).response);
                        setAdditionalInformation(orderDetailsForCSRRef.current && orderDetailsForCSRRef.current.additionalDetails);
                        if (props.orderId) {
                            if (orderDetailsForCSRRef.current) {
                                orderDetailsForCSRRef.current.shippingDetails && setShippingDetails(orderDetailsForCSRRef.current.shippingDetails);
                                orderDetailsForCSRRef.current.billingDetails && setBillingDetails(orderDetailsForCSRRef.current.billingDetails);
                                orderDetailsForCSRRef.current.productDetails && setProductDetails(orderDetailsForCSRRef.current.productDetails);
                                if (shippingDetailsRef.current && billingDetailsRef.current && productDetailsRef.current) {
                                    setShowOrderDetail(true);
                                } else {
                                    setShowOrderDetail(false);
                                }
                                if (billingDetailsRef.current.PaymentType && billingDetailsRef.current.PaymentType === 'Credit Card') {
                                    setIsCreditType(true);
                                } else {
                                    setIsCreditType(false);
                                }
                            }
                        }
                        else {
                            setShowOrderDetail(false);
                        }

                    }
                    else {
                        const orderItems = JSON.parse(res.response)
                        Object.entries(JSON.parse(res.response).response).map(([key, orderList], index) => {
                            setOrderDetail(orderList)
                        })
                        // setShowOrderDetail(true);
                        if (orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.PaymentType === 'Credit Card') {
                            setIsCreditType(true);
                        } else {
                            setIsCreditType(false);
                        }
                    }

                    setIsLoading(false)
                } else {
                    const error = res.result;
                    setIsLoading(false)
                }
            })
    }

    var productIds = [];
    const [productIdListJoin, setProductIdListJoin, productIdListJoinRef] = useStateRef("");

    useEffect(() => {

        if (orderDetailRef.current) {
            // special items
            { orderDetailRef.current && orderDetailRef.current.dropShipItems ? specialListItems.push(orderDetailRef.current.dropShipItems) : "" }
            { orderDetailRef.current && orderDetailRef.current.backOrderLivingMaterialItems ? specialListItems.push(orderDetailRef.current.backOrderLivingMaterialItems) : "" }
            { orderDetailRef.current && orderDetailRef.current.groundOnlyItems ? specialListItems.push(orderDetailRef.current.groundOnlyItems) : "" }
            { orderDetailRef.current && orderDetailRef.current.softGoodsItems ? specialListItems.push(orderDetailRef.current.softGoodsItems) : "" }
            { orderDetailRef.current && orderDetailRef.current.rtsProductsItems ? specialListItems.push(orderDetailRef.current.rtsProductsItems) : "" }
            { orderDetailRef.current && orderDetailRef.current.SoftGoodDisplayItems ? specialListItems.push(orderDetailRef.current.SoftGoodDisplayItems) : "" }
            // living items
            { orderDetailRef.current.livingMaterialItems ? livingListItems.push(orderDetailRef.current.livingMaterialItems) : "" }
            { orderDetailRef.current.specialLivingMaterialItems ? livingListItems.push(orderDetailRef.current.specialLivingMaterialItems) : "" }

            // non-living items
            { orderDetailRef.current.nonLiveMaterialItems ? nonLivingListItems.push(orderDetailRef.current.nonLiveMaterialItems) : "" }


            for (var j = 0; j < specialListItems.length > 0; j++) {
                setSpecialItems(specialListItems)
            }
            for (var j = 0; j < livingListItems.length > 0; j++) {
                setLivingItems(livingListItems)
            }
            for (var j = 0; j < nonLivingListItems.length > 0; j++) {
                setNonLivingItems(nonLivingListItems)
            }

            specialItemsRef.current && specialItemsRef.current.length > 0 && Object.entries(specialItemsRef.current).map(([key, itemLists], index) => {
                itemLists && Object.entries(itemLists).map(([key, item], index) => {
                    productIds.push(item.itemNumber);
                })
            })
            livingItemsRef.current && livingItemsRef.current.length > 0 && Object.entries(livingItemsRef.current).map(([key, itemLists], index) => {
                itemLists && Object.entries(itemLists).map(([key, item], index) => {
                    productIds.push(item.itemNumber);
                })
            })
            nonLivingItemsRef.current && nonLivingItemsRef.current.length > 0 && Object.entries(nonLivingItemsRef.current).map(([key, itemLists], index) => {
                itemLists && Object.entries(itemLists).map(([key, item], index) => {
                    productIds.push(item.itemNumber);
                })
            })

            if (productIds.length > 0) {
                setProductIdListJoin(productIds.join(","));
            }

        }
    }, [orderDetailRef.current])

    const handleClearErrMsg = () => {
        if (document.getElementById("errMsgAlert")) {
            document.getElementById("errMsgAlert").classList.remove("d-block")
            document.getElementById("errMsgAlert").classList.add("d-none")
        }
        if (document.getElementById("eventName")) {
            document.getElementById("eventName").classList.remove("form-error")
        }

    }

    useEffect(() => {
        if (productDetailsRef.current) {

            { productDetailsRef.current && productDetailsRef.current.dropShipItems ? specialListItems.push(productDetailsRef.current.dropShipItems) : "" }
            { productDetailsRef.current && productDetailsRef.current.backOrderLivingMaterialItems ? specialListItems.push(productDetailsRef.current.backOrderLivingMaterialItems) : "" }
            { productDetailsRef.current && productDetailsRef.current.groundOnlyItems ? specialListItems.push(productDetailsRef.current.groundOnlyItems) : "" }
            { productDetailsRef.current && productDetailsRef.current.softGoodsItems ? specialListItems.push(productDetailsRef.current.softGoodsItems) : "" }
            { productDetailsRef.current && productDetailsRef.current.rtsProductsItems ? specialListItems.push(productDetailsRef.current.rtsProductsItems) : "" }
            { productDetailsRef.current && productDetailsRef.current.SoftGoodDisplayItems ? specialListItems.push(productDetailsRef.current.SoftGoodDisplayItems) : "" }
            // living items
            { productDetailsRef.current.livingMaterialItems ? livingListItems.push(productDetailsRef.current.livingMaterialItems) : "" }
            { productDetailsRef.current.specialLivingMaterialItems ? livingListItems.push(productDetailsRef.current.specialLivingMaterialItems) : "" }

            // non-living items
            { productDetailsRef.current.nonLiveMaterialItems ? nonLivingListItems.push(productDetailsRef.current.nonLiveMaterialItems) : "" }

            for (var j = 0; j < specialListItems.length > 0; j++) {
                setSpecialItems(specialListItems)
            }
            for (var j = 0; j < livingListItems.length > 0; j++) {
                setLivingItems(livingListItems)
            }
            for (var j = 0; j < nonLivingListItems.length > 0; j++) {
                setNonLivingItems(nonLivingListItems)
            }
        }
    }, [productDetailsRef.current])

    function modifyState() {
        let stateObj = { id: "100" };
        var cartUrl = `?orderId=${orderIdStateRef.current}&showCart=true&event=cart_updated`
        window.history.replaceState(stateObj,
            "showCart", cartUrl);
    }

    async function handleReorder(event) {
        event.preventDefault();
        const reorderOrderId = event.currentTarget.getAttribute("orderIdState")
        const index = event.currentTarget.getAttribute("index")
        setOrderItemId(reorderOrderId)
        var actionUrl = "api/rest/cb/order/reorder";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            reorderOrderId: reorderOrderId
        }))
        if (res.result == "success") {
            var response = (JSON.parse(res.response))?.response
            const isCartModalFlagObj = response?.find(obj => obj.isCartModalFlag !== undefined);
            const isCartEmptyFlag = isCartModalFlagObj ? isCartModalFlagObj.isCartModalFlag : "";
            const messageObj = (JSON.parse(res.response))?.errorMessage
            if (isCartEmptyFlag === false) {
                setCartModal(true)
                var modalElement = document.getElementById(`recorderModal${index}`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();
            } else if (Array.isArray(messageObj)) {
                const messages = messageObj.map(error => error.message).join('<br/>');
                dispatch(updateProfileDetailsAction(true, "cart"))
                setErrorMsg(messages)
            }
            else {
                modifyState()
                dispatch(updateProfileDetailsAction(true, "cart"))
                setCartUpdatedModal(true)
                var modalElement = document.getElementById(`addProductToCartModal${index}`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();
                const itemCheck = JSON.parse(res?.response);
                setOderItemDetail(itemCheck?.response[0])
            //    handleSiteSpecDataLayer(orderItemDetailRef.current?.response?.validproducts)
            }
        }
        else {
            console.log("errorList-----", res)
        }

    }

    function handleSiteSpecDataLayer(validateProduct) {
        let productList = []
        {
            validateProduct?.map((oneProduct) => {
                let categoryList = [];
                let category = oneProduct?.dataLayer_obj
                const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

                categoryList = categoryList1;
                const productMapDuplicate = {
                    "productId": oneProduct.ProductId,
                    "category": categoryList
                }
                let productMap = productMapDuplicate;
                productList.push(productMap)
            })
        }

        const page = {
            "type": "product",
            "products": productList
        }
        const ORDERDETAIL_payload = {
            "page": page
        }
        window.ssRecsInfo = window.ssRecsInfo || {}
        window.ssRecsInfo = ORDERDETAIL_payload
        window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': ORDERDETAIL_payload}))
    }
    async function handleKeepExistingItem(event) {
        event.preventDefault();
        const reorderOrderId = orderItemIdRef.current;
        const action = event.currentTarget.getAttribute("action")
        const index = event.currentTarget.getAttribute("index")
        var actionUrl = "api/rest/cb/order/reorder-from-modal";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            reorderOrderId: orderItemIdRef.current,
            action: action
        }))
        if (res.result == "success") {
            const messageObj = (JSON.parse(res.response))?.errorMessage

            if (Array.isArray(messageObj)) {
                const messages = messageObj.map(error => error.message).join('<br/>');
                document.getElementById(`recorderModal-close${index}`).click()
                dispatch(updateProfileDetailsAction(true, "cart"))
                setErrorMsg(messages)
            } else {
                modifyState()
                document.getElementById(`recorderModal-close${index}`).click()
                setCartUpdatedModal(true)
                var modalElement = document.getElementById(`addProductToCartModal${index}`);
                var bootstrapModal = new bootstrap.Modal(modalElement);
                bootstrapModal.show();
                dispatch(updateProfileDetailsAction(true, "cart"))
                setOderItemDetail((JSON.parse(res.response))?.response)
            //    handleSiteSpecDataLayer(orderItemDetailRef.current?.response?.validproducts)
            }
        }
        else {
            console.log("errorList-----", res)
        }
    }

    async function handleSubmitOrder(event) {
        event.preventDefault();
        var actionUrl = "/api/rest/cb/profile/submit-temp-b2i-order";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = { orderId: orderDetailsForCSRRef.current.atgOrderId };
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
        if (res.response != null) {
            var response = res.response ? res.response.response : '';
            var error = response ? JSON.parse(response).error : '';
            if (error === 'false') {
                setIsSubmittedOrder(true);
            }
        } else {
            console.log('res.response...', res.response);
        }
    }

    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
    return (
        <div data-cont-id={props.containerObject ? props.containerObject.contentId : ""} data-zone={props.dataZone ? props.dataZone : ""} data-page-id={props.contentId ? props.contentId : ""} data-template-name={props.templateName ? props.templateName : ""} className={`vast-plugin-content row gx-0 c-order-detail c-shopping-list-item-padding`}>
            {showOrderDetailRef.current  ?
                <>
                    {isLoading ? <Loader /> : ""}
                    <AddShoppingListModal orderId={orderIdStateRef.current ? orderIdStateRef.current : ""} productId={productIdListJoinRef.current ? productIdListJoinRef.current : ""} />

                    {props.isCSR ? <>{additionalInformationRef.current && <AdditionalInformation additionalInformation={additionalInformationRef.current} userId={replaceUserIdRef.current} showSubmitOrderError={showSubmitOrderErrorRef.current} handleOrderDetails={handleOrderDetails} />} </> : ''}

                    <div className="col-lg-12 c-shopping-list-item-col c-details-page">
                        <div id="add-item-error-message" className={`message message-red ${errorMsgRef.current ? 'd-block' : 'd-none'}`}>
                            <p dangerouslySetInnerHTML={{ __html: errorMsgRef.current }}></p>
                        </div>
                        <div className="row my-2 my-md-2">
                            <div className="col-6 col-md-6">
                                <h1 className="c-account-list-heading">{props.isCSR && props.hasOrderNumber ? <Link to={`/account/order-detail?orderId=${orderIdStateRef.current && orderIdStateRef.current}&userId=${replaceUserIdRef.current && replaceUserIdRef.current}`} >Order ID: {orderDetailsForCSRRef.current.atgOrderId && orderDetailsForCSRRef.current.atgOrderId}</Link> : props.isCSR ? <>Order # {orderDetailsForCSRRef.current?.atgOrderId}</> : <>Order # {orderDetailRef.current.webOrderId && orderDetailRef.current.webOrderId}</>} </h1>
                            </div>
                            {!props.isCSR &&
                                <div className="col-6 col-md-6 d-lg-none">
                                    <CbMobileLogOut />
                                </div>
                            }
                            {currentUrlRef.current == "checkout/order-detail" ? "":<>
                            {props.isCSR || userIdParamRef.current == null ? '' :
                                <div className="col-12 col-md-6 text-md-end text-center my-2 my-md-0 c-order-mobile-btn">
                                    <button type="button" className="btn btn-primary modal-link me-1" data-bs-toggle="modal" data-bs-dismiss="modal" onClick={handleClearErrMsg} data-bs-target="#newListModalww">
                                        Add to List
                                    </button>
                                    <button type="button" onClick={handleReorder} index="0" orderIdState={orderIdStateRef.current} id='orderIdState' className="btn btn-secondary" >
                                        Reorder
                                    </button>
                                </div>
                            }</>}

                        </div>
                        {props.isCSR ? <></> : <hr />}
                        <div className="row mt-4">
                            <div className="col-md-6">
                                <div className={props.isCSR ? "c-order-details c-order-details-csr" : "c-order-details"}>
                                    {!isCreditTypeRef.current &&
                                        <>
                                            {
                                                <div class="row">
                                                    <div class="col-6 col-md-4">
                                                        <label>Payment:</label>
                                                    </div>
                                                    <div class="col-6 col-md-4">
                                                        <p>{props.isCSR ? billingDetailsRef.current && billingDetailsRef.current.PaymentType : orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.PaymentType}</p>
                                                    </div>
                                                </div>}
                                            {props.isCSR ?
                                                <>
                                                    {billingDetailsRef.current && billingDetailsRef.current.PONumber ?
                                                        <div class="row">
                                                            <div class="col-6 col-md-4">
                                                                <label>PO Number:</label>
                                                            </div>
                                                            <div class="col-6 col-md-4">
                                                                {billingDetailsRef.current.PONumber ? <p>{billingDetailsRef.current.PONumber}</p> : ''}
                                                            </div>
                                                        </div>
                                                        : ""}
                                                </>
                                                :
                                                <>
                                                    {orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.PONumber ?
                                                        <div class="row">
                                                            <div class="col-6 col-md-4">
                                                                <label>PO Number:</label>
                                                            </div>
                                                            <div class="col-6 col-md-4">
                                                                <p>{orderDetailRef.current.billingDetails.PONumber}</p>
                                                            </div>
                                                        </div>
                                                        : ""}
                                                </>}

                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Billing Address:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <address>
                                                        {props.isCSR ?
                                                            <>{billingDetailsRef.current &&
                                                                <>
                                                                    {billingDetailsRef.current.firstName || billingDetailsRef.current.lastName ?
                                                                        <>
                                                                            {billingDetailsRef.current.firstName && billingDetailsRef.current.firstName + " "}{billingDetailsRef.current.lastName && billingDetailsRef.current.lastName}
                                                                            <br />
                                                                        </> : ''
                                                                    }
                                                                    {billingDetailsRef.current.companyName &&
                                                                        <>
                                                                            {billingDetailsRef.current.companyName}
                                                                            <br />
                                                                        </>
                                                                    }
                                                                    {billingDetailsRef.current.address1 &&
                                                                        <>
                                                                            {billingDetailsRef.current.address1}
                                                                            <br />
                                                                        </>
                                                                    }
                                                                    {billingDetailsRef.current.address2 &&
                                                                        <>
                                                                            {billingDetailsRef.current.address2}
                                                                            <br />
                                                                        </>
                                                                    }
                                                                    {billingDetailsRef.current.city || billingDetailsRef.current.State || billingDetailsRef.current.postalCode ?
                                                                        <>
                                                                            {billingDetailsRef.current.city && billingDetailsRef.current.city + ' '},{billingDetailsRef.current.State && billingDetailsRef.current.State + ' '}{billingDetailsRef.current.postalCode && billingDetailsRef.current.postalCode}
                                                                            <br />
                                                                        </> : ''
                                                                    }

                                                                </>
                                                            }
                                                            </>
                                                            :
                                                            <>

                                                                {orderDetailRef.current && orderDetailRef.current.billingDetails &&
                                                                    <>
                                                                        {orderDetailRef.current.billingDetails.firstName || orderDetailRef.current.billingDetails.lastName ?
                                                                            <>

                                                                                {orderDetailRef.current.billingDetails.firstName && orderDetailRef.current.billingDetails.firstName} {orderDetailRef.current.billingDetails.lastName && orderDetailRef.current.billingDetails.lastName}
                                                                                <br />
                                                                            </> : ''
                                                                        }
                                                                        {orderDetailRef.current.billingDetails.companyName &&
                                                                            <>
                                                                                {orderDetailRef.current.billingDetails.companyName}
                                                                                <br />
                                                                            </>

                                                                        }
                                                                        {orderDetailRef.current.billingDetails.address1 &&
                                                                            <>
                                                                                {orderDetailRef.current.billingDetails.address1}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {orderDetailRef.current.billingDetails.address2 &&
                                                                            <>
                                                                                {orderDetailRef.current.billingDetails.address2}
                                                                                <br />
                                                                            </>

                                                                        }
                                                                        {orderDetailRef.current.billingDetails.city || orderDetailRef.current.billingDetails.State || orderDetailRef.current.billingDetails.postalCode ?
                                                                            <>
                                                                                {orderDetailRef.current.billingDetails.city && orderDetailRef.current.billingDetails.city}, {orderDetailRef.current.billingDetails.State && orderDetailRef.current.billingDetails.State}<br /> {orderDetailRef.current.billingDetails.postalCode && orderDetailRef.current.billingDetails.postalCode}
                                                                                <br />
                                                                            </> : ''
                                                                        }


                                                                        {orderDetailRef.current.billingDetails.primaryPhone ?
                                                                            <>
                                                                                Primary Phone:
                                                                                <br />
                                                                                {orderDetailRef.current.billingDetails.primaryPhone}
                                                                                <br />
                                                                            </> : ""}

                                                                    </>
                                                                }

                                                            </>}
                                                    </address>
                                                </div>
                                            </div>
                                        </>}

                                    {isCreditTypeRef.current &&
                                        <>
                                            <h2 className="c-order-details-heading">Billing & Payment</h2>
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Billing Address:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <address>
                                                        {props.isCSR ?
                                                            <>
                                                                {billingDetailsRef.current &&
                                                                    <>
                                                                        {billingDetailsRef.current.firstName || billingDetailsRef.current.lastName ?
                                                                            <>
                                                                                {billingDetailsRef.current.firstName && billingDetailsRef.current.firstName + " "}{billingDetailsRef.current.lastName && billingDetailsRef.current.lastName}
                                                                                <br />
                                                                            </> : ''
                                                                        }
                                                                        {billingDetailsRef.current.companyName &&
                                                                            <>
                                                                                {billingDetailsRef.current.companyName}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {billingDetailsRef.current.address1 &&
                                                                            <>
                                                                                {billingDetailsRef.current.address1}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {billingDetailsRef.current.address2 &&
                                                                            <>
                                                                                {billingDetailsRef.current.address2}
                                                                                <br />
                                                                            </>
                                                                        }

                                                                        {billingDetailsRef.current.city || billingDetailsRef.current.State || billingDetailsRef.current.postalCode ?
                                                                            <>
                                                                                {billingDetailsRef.current.city && billingDetailsRef.current.city},&nbsp;{billingDetailsRef.current && billingDetailsRef.current.State}&nbsp;{billingDetailsRef.current && billingDetailsRef.current.postalCode}
                                                                                <br />
                                                                            </> : ''
                                                                        }

                                                                    </>

                                                                }
                                                            </>
                                                            :
                                                            <>{orderDetailRef.current && orderDetailRef.current.billingDetails &&
                                                                <>
                                                                    {orderDetailRef.current.billingDetails.firstName || orderDetailRef.current.billingDetails.lastName ?
                                                                        <>

                                                                            <>{orderDetailRef.current.billingDetails.firstName ? orderDetailRef.current.billingDetails.firstName : ''}&nbsp;{orderDetailRef.current.billingDetails.lastName ? orderDetailRef.current.billingDetails.lastName : ''}</>
                                                                            <br />
                                                                        </> : ''
                                                                    }
                                                                    {orderDetailRef.current.billingDetails.companyName &&
                                                                        <>
                                                                            {orderDetailRef.current.billingDetails.companyName}
                                                                            <br />
                                                                        </>
                                                                    }
                                                                    {orderDetailRef.current.billingDetails.address1 &&
                                                                        <>
                                                                            {orderDetailRef.current.billingDetails.address1}
                                                                            <br />
                                                                        </>
                                                                    }
                                                                    {orderDetailRef.current.billingDetails.address2 &&
                                                                        <>
                                                                            {orderDetailRef.current.billingDetails.address2}
                                                                            <br />
                                                                        </>
                                                                    }

                                                                    {orderDetailRef.current.billingDetails.city || orderDetailRef.current.billingDetails.State || orderDetailRef.current.billingDetails.postalCode ?
                                                                        <>
                                                                            {orderDetailRef.current.billingDetails.city && orderDetailRef.current.billingDetails.city}, {orderDetailRef.current.billingDetails.State && orderDetailRef.current.billingDetails.State} {orderDetailRef.current.billingDetails.postalCode && orderDetailRef.current.billingDetails.postalCode}
                                                                            <br />
                                                                        </> : ''
                                                                    }

                                                                </>

                                                            }

                                                                {orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.primaryPhone ?
                                                                    <>
                                                                        Primary Phone:
                                                                        <br />
                                                                        {orderDetailRef.current.billingDetails.primaryPhone}
                                                                    </> : ""}
                                                                <br />
                                                            </>}
                                                    </address>
                                                </div>
                                            </div>
                                            {props.isCSR && billingDetailsRef.current && billingDetailsRef.current.primaryPhone ?

                                                <div className="row">
                                                    <div className="col-6 col-md-4">
                                                        <label>Primary Phone:</label>
                                                    </div>
                                                    <div className="col-6 col-md-4">
                                                        <p>{billingDetailsRef.current.primaryPhone}</p>
                                                    </div>
                                                </div>
                                                : ''
                                            }
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Payment:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <p>{props.isCSR ? <>{billingDetailsRef.current.PaymentType && billingDetailsRef.current.PaymentType}</> : <>{orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.PaymentType}</>}</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Card Type:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <p className="mb-0">
                                                        {props.isCSR ? <>{billingDetailsRef.current?.cardType && capitalizeFirstLetter(billingDetailsRef.current.cardType)}</> : <>{orderDetailRef.current?.billingDetails?.cardType && capitalizeFirstLetter(orderDetailRef.current.billingDetails.cardType)}</>}
                                                    </p>
                                                    <p>{props.isCSR ? <>{billingDetailsRef.current && billingDetailsRef.current.creditCardNumber && <>Ending in &nbsp;{billingDetailsRef.current.creditCardNumber}</>}</> : <>{orderDetailRef.current && orderDetailRef.current?.billingDetails?.creditCardNumber && <> Ending in &nbsp;{orderDetailRef.current.billingDetails.creditCardNumber}</>}</>}</p>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Expiration:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <p>{props.isCSR ? <>{billingDetailsRef.current && billingDetailsRef.current.expirationMonth}/{billingDetailsRef.current && billingDetailsRef.current.expirationYear}</> : <>{orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.expirationMonth}/{orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.expirationYear}</>}   </p>
                                                </div>
                                            </div>
                                            {orderDetailRef.current && orderDetailRef.current.billingDetails && orderDetailRef.current.billingDetails.cardPoRefNumber ?
                                                <div class="row">
                                                    <div class="col-6 col-md-4">
                                                        <label>PO Number:</label>
                                                    </div>
                                                    <div class="col-6 col-md-4">
                                                        <p>{orderDetailRef.current.billingDetails.cardPoRefNumber}</p>
                                                    </div>
                                                </div> : ''}
                                            {props.isCSR ?
                                                <>{billingDetailsRef.current?.cardPoRefNumber ?
                                                    <div class="row">
                                                        <div class="col-6 col-md-4">
                                                            <label>PO Number:</label>
                                                        </div>
                                                        <div class="col-6 col-md-4">
                                                            <p>{billingDetailsRef.current.cardPoRefNumber}</p>
                                                        </div>
                                                    </div>
                                                    : <></>
                                                }
                                                </> : ''

                                            }
                                        </>}

                                </div>
                            </div>
                            <div className="col-md-6">
                                {props.isCSR || (orderDetailRef.current && Object.keys(orderDetailRef.current.shippingDetails).length > 0) ?
                                    <div className={props.isCSR ? "c-order-details c-order-details-csr" : "c-order-details"}>
                                        {props.isCSR ? <h2 className="c-order-details-heading">{orderDetailsForCSRRef.current?.userType === 2 ? 'Shipping & Recipient' : 'Shipping'}</h2> : profile?.userType === 1 ?
                                            <h2 className="c-order-details-heading">Shipping</h2>
                                            : <h2 className="c-order-details-heading">Shipping & Recipient</h2>}
                                        {props.isCSR || orderDetailRef.current && orderDetailRef.current.shippingDetails ?
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Shipping Address:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <address>
                                                        {props.isCSR ?
                                                            <>
                                                                {shippingDetailsRef.current &&
                                                                    <>
                                                                        {orderDetailsForCSRRef.current?.userType === 1 && shippingDetailsRef.current?.firstName && shippingDetailsRef.current?.lastName &&
                                                                            <>
                                                                                {shippingDetailsRef.current && shippingDetailsRef.current?.firstName} {shippingDetailsRef.current && shippingDetailsRef.current?.lastName}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {shippingDetailsRef.current.companyName &&
                                                                            <>
                                                                                {shippingDetailsRef.current && shippingDetailsRef.current.companyName}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {shippingDetailsRef.current.address1 &&
                                                                            <>
                                                                                {shippingDetailsRef.current && shippingDetailsRef.current.address1}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {shippingDetailsRef.current.address2 &&
                                                                            <>
                                                                                {shippingDetailsRef.current && shippingDetailsRef.current.address2}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {shippingDetailsRef.current.city || shippingDetailsRef.current.state || shippingDetailsRef.current.postalCode ?
                                                                            <>
                                                                                {shippingDetailsRef.current.city && shippingDetailsRef.current.city},&nbsp;{shippingDetailsRef.current.state && shippingDetailsRef.current.state}&nbsp;{shippingDetailsRef.current.postalCode && shippingDetailsRef.current.postalCode}
                                                                                <br />
                                                                            </> : ''
                                                                        }
                                                                    </>
                                                                }

                                                            </>
                                                            :
                                                            <>
                                                                {orderDetailRef.current && orderDetailRef.current.shippingDetails &&
                                                                    <>
                                                                        {profile?.userType === 1 && orderDetailRef.current?.shippingDetails?.firstName && orderDetailRef.current?.shippingDetails?.lastName &&
                                                                            <>
                                                                                {orderDetailRef.current.shippingDetails.firstName} {orderDetailRef.current.shippingDetails.lastName}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {orderDetailRef.current.shippingDetails.companyName &&
                                                                            <>
                                                                                {orderDetailRef.current.shippingDetails.companyName}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {orderDetailRef.current.shippingDetails.address1 &&
                                                                            <>
                                                                                {orderDetailRef.current.shippingDetails.address1}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {orderDetailRef.current.shippingDetails.address2 &&
                                                                            <>
                                                                                {orderDetailRef.current.shippingDetails.address2}
                                                                                <br />
                                                                            </>
                                                                        }
                                                                        {orderDetailRef.current.shippingDetails.city || orderDetailRef.current.shippingDetails.state || orderDetailRef.current.shippingDetails.postalCode ?
                                                                            <>
                                                                                {orderDetailRef.current.shippingDetails.city && orderDetailRef.current.shippingDetails.city}, {orderDetailRef.current.shippingDetails.state && orderDetailRef.current.shippingDetails.state} {orderDetailRef.current.shippingDetails.postalCode && orderDetailRef.current.shippingDetails.postalCode}
                                                                                <br />
                                                                            </> : ''
                                                                        }
                                                                    </>
                                                                }
                                                                <br />
                                                            </>
                                                        }
                                                    </address>
                                                </div>
                                            </div>
                                            : ''}
                                        {profile?.userType === 2 &&
                                            orderDetailRef.current && orderDetailRef.current.shippingDetails || orderDetailsForCSRRef.current?.userType === 2 && shippingDetailsRef.current?.firstName && shippingDetailsRef.current?.lastName ?
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Recipient:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <p>{props.isCSR ? <>{shippingDetailsRef.current.firstName} {shippingDetailsRef.current.lastName}</> :
                                                        <>{orderDetailRef.current?.shippingDetails?.firstName} {orderDetailRef.current?.shippingDetails?.lastName}</>}</p>
                                                </div>
                                            </div>
                                            : ''}
                                        {shippingDetailsRef.current?.location || orderDetailRef.current?.shippingDetails?.location ?
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Bldg / Dept / Room:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <p>{props.isCSR ? shippingDetailsRef.current.location : orderDetailRef.current.shippingDetails.location}
                                                    </p>
                                                </div>
                                            </div>
                                            :
                                            <>

                                            </>
                                        }
                                        {orderDetailRef.current?.shippingDetails?.recipientEmail ?
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Email:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <p>
                                                        {orderDetailRef.current.shippingDetails.recipientEmail}
                                                    </p>
                                                </div>
                                            </div>
                                            : shippingDetailsRef.current && shippingDetailsRef.current.recipientEmail ?
                                                <div className="row">
                                                    <div className="col-6 col-md-4">
                                                        <label>Email:</label>
                                                    </div>
                                                    <div className="col-6 col-md-4">
                                                        <p>
                                                            {props.isCSR ? <>{shippingDetailsRef.current && shippingDetailsRef.current.recipientEmail && shippingDetailsRef.current.recipientEmail}</> : ''}
                                                        </p>
                                                    </div>
                                                </div> :
                                                ''
                                        }
                                        {orderDetailRef.current?.shippingDetails?.primaryPhoneNumber ?
                                            <div className="row">
                                                <div className="col-6 col-md-4">
                                                    <label>Primary Phone:</label>
                                                </div>
                                                <div className="col-6 col-md-4">
                                                    <p>{orderDetailRef.current.shippingDetails.primaryPhoneNumber}</p>
                                                </div>
                                            </div>
                                            : shippingDetailsRef.current && shippingDetailsRef.current.primaryPhoneNumber ?
                                                <div className="row">
                                                    <div className="col-6 col-md-4">
                                                        <label>Primary Phone:</label>
                                                    </div>
                                                    <div className="col-6 col-md-4">
                                                        <p>{shippingDetailsRef.current.primaryPhoneNumber}</p>
                                                    </div>
                                                </div> : ''}
                                    </div>
                                    : ''}
                            </div>
                        </div>

                        <h2 className="c-order-details-heading">Your Items</h2>

                        {specialItemsRef.current.length > 0 ?
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="c-order-section-heading">Special Items</h2>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="c-list-table c-order-history">
                                                <ul className="c-shop-list mt-0">
                                                    <li className="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                                        <div className="c-list-left c-order-deatils-left">
                                                            <span className="c-shop-list-content">Delivery Date</span>
                                                            <span className="c-shop-list-content">Item #</span>
                                                            <span className="c-shop-list-content c-order-product-width">Product</span>
                                                            <span className="c-shop-list-content">Qty</span>
                                                            <span className="c-shop-list-content">Your Price</span>
                                                            <span className="c-shop-list-content">Item Total</span>
                                                        </div>
                                                    </li>
                                                </ul>

                                                <ul className="c-shop-list mb-0">

                                                    {specialItemsRef.current && Object.entries(specialItemsRef.current).map(([key, itemLists], index) => {
                                                        return (<>
                                                            {itemLists && Object.entries(itemLists).map(([key, itemList], index) => {
                                                                var dateObject = new Date(itemList.deliveryDate);
                                                                var day = dateObject.getDate();
                                                                var month = dateObject.getMonth() + 1;
                                                                var year = dateObject.getFullYear();
                                                                day = day < 10 ? '0' + day : day;
                                                                month = month < 10 ? '0' + month : month;
                                                                var formattedDate = month + '/' + day + '/' + year;
                                                                return (<>
                                                                    <li className="c-shop-list-item c-shop-list-body">
                                                                        <div className={props.isCSR ? "c-list-left c-order-deatils-left c-csr-order-details" : "c-list-left c-order-deatils-left"}>

                                                                            {itemList.shippingMethod == "electronicShippingGroup" ? '' : <span className="c-shop-list-content c-order-col-01">
                                                                                <p><span className="d-block d-md-none c-shop-mobile-label">Delivery Date: </span>{formattedDate}</p>
                                                                                <p>{itemList.shippingMethod}</p>
                                                                            </span>}
                                                                            <span className="c-shop-list-content "><span className="d-block d-md-none c-shop-mobile-label">Item #</span>{itemList.itemNumber}</span>
                                                                            <span className="c-shop-list-content c-order-product-width c-order-detail-product-desc"><strong dangerouslySetInnerHTML={{ __html: itemList.productDesc }}></strong></span>
                                                                            <span className="c-shop-list-content "><span className="d-block d-md-none c-shop-mobile-label">Qty:</span>{itemList.quantity}</span>

                                                                            <span className="c-shop-list-content c-order-details-price">
                                                                                <span className="d-block d-md-none c-shop-mobile-label">Your Price:</span>
                                                                                {itemList.price}
                                                                            </span>
                                                                            <span className="c-shop-list-content c-order-details-price">
                                                                                <span className="d-block d-md-none c-shop-mobile-label"><strong>Item Total:</strong></span>
                                                                                <strong>{itemList.itemTotal}</strong>
                                                                            </span>
                                                                        </div>
                                                                    </li>
                                                                </>
                                                                )
                                                            })}
                                                        </>
                                                        )
                                                    })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            : ""}

                        {livingItemsRef.current.length > 0 ?
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="c-order-section-heading">Living & Perishable Items</h2>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="c-list-table c-order-history">
                                                <ul className="c-shop-list mt-0">
                                                    <li className="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                                        <div className="c-list-left c-order-deatils-left">
                                                            <span className="c-shop-list-content">Delivery Date</span>
                                                            <span className="c-shop-list-content">Item #</span>
                                                            <span className="c-shop-list-content c-order-product-width">Product</span>
                                                            <span className="c-shop-list-content">Qty</span>
                                                            <span className="c-shop-list-content">Your Price</span>
                                                            <span className="c-shop-list-content">Item Total</span>
                                                        </div>
                                                    </li>
                                                </ul>

                                                <ul className="c-shop-list mb-0">

                                                    {livingItemsRef.current && Object.entries(livingItemsRef.current).map(([key, itemLists], index) => {
                                                        return (<>
                                                            {itemLists && Object.entries(itemLists).map(([key, itemList], index) => {
                                                                var dateObject = new Date(itemList.deliveryDate);
                                                                var day = dateObject.getDate();
                                                                var month = dateObject.getMonth() + 1;
                                                                var year = dateObject.getFullYear();
                                                                day = day < 10 ? '0' + day : day;
                                                                month = month < 10 ? '0' + month : month;
                                                                var formattedDate = month + '/' + day + '/' + year;
                                                                return (<>
                                                                    <li className="c-shop-list-item c-shop-list-body">
                                                                        <div className={props.isCSR ? "c-list-left c-order-deatils-left c-csr-order-details" : "c-list-left c-order-deatils-left"}>
                                                                            <span className="c-shop-list-content c-order-col-01">
                                                                                <p><span className="d-block d-md-none c-shop-mobile-label">Delivery Date: </span>{formattedDate}</p>
                                                                                <p>{itemList.shippingMethod}</p>
                                                                            </span>
                                                                            <span className="c-shop-list-content "><span className="d-block d-md-none c-shop-mobile-label">Item #</span>{itemList.itemNumber}</span>
                                                                            <span className="c-shop-list-content c-order-product-width c-order-detail-product-desc"><strong dangerouslySetInnerHTML={{ __html: itemList.productDesc }}></strong></span>
                                                                            <span className="c-shop-list-content "><span className="d-block d-md-none c-shop-mobile-label">Qty:</span>{itemList.quantity}</span>

                                                                            <span className="c-shop-list-content c-order-details-price">
                                                                                <span className="d-block d-md-none c-shop-mobile-label">Your Price:</span>
                                                                                {itemList.price}
                                                                            </span>
                                                                            <span className="c-shop-list-content c-order-details-price">
                                                                                <span className="d-block d-md-none c-shop-mobile-label"><strong>Item Total:</strong></span>
                                                                                <strong>{itemList.itemTotal}</strong>
                                                                            </span>
                                                                        </div>
                                                                    </li>
                                                                </>
                                                                )
                                                            })}
                                                        </>
                                                        )
                                                    })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            : ""}

                        {nonLivingItemsRef.current.length > 0 ?
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="c-order-section-heading">In-Stock Items (non-Live & Perishable) </h2>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="c-list-table c-order-history">
                                                <ul className="c-shop-list mt-0">
                                                    <li className="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                                        <div className="c-list-left c-order-deatils-left">
                                                            <span className="c-shop-list-content">Delivery Date</span>
                                                            <span className="c-shop-list-content">Item #</span>
                                                            <span className="c-shop-list-content c-order-product-width">Product</span>
                                                            <span className="c-shop-list-content">Qty</span>
                                                            <span className="c-shop-list-content">Your Price</span>
                                                            <span className="c-shop-list-content">Item Total</span>
                                                        </div>
                                                    </li>
                                                </ul>

                                                <ul className="c-shop-list mb-0">

                                                    {nonLivingItemsRef.current && Object.entries(nonLivingItemsRef.current).map(([key, itemLists], index) => {
                                                        return (<>
                                                            {itemLists && Object.entries(itemLists).map(([key, itemList], index) => {
                                                                var dateObject = new Date(itemList.deliveryDate);
                                                                var day = dateObject.getDate();
                                                                var month = dateObject.getMonth() + 1;
                                                                var year = dateObject.getFullYear();
                                                                day = day < 10 ? '0' + day : day;
                                                                month = month < 10 ? '0' + month : month;
                                                                var formattedDate = month + '/' + day + '/' + year;
                                                                return (<>
                                                                    <li className="c-shop-list-item c-shop-list-body">
                                                                        <div className={props.isCSR ? "c-list-left c-order-deatils-left c-csr-order-details" : "c-list-left c-order-deatils-left"}>
                                                                            <span className="c-shop-list-content c-order-col-01">
                                                                                <p><span className="d-block d-md-none c-shop-mobile-label">Delivery Date: </span>{formattedDate}</p>
                                                                                <p>{itemList.shippingMethod}</p>
                                                                            </span>
                                                                            <span className="c-shop-list-content "><span className="d-block d-md-none c-shop-mobile-label">Item #</span>{itemList.itemNumber}</span>
                                                                            <span className="c-shop-list-content c-order-product-width c-order-detail-product-desc"><strong dangerouslySetInnerHTML={{ __html: itemList.productDesc }}></strong></span>
                                                                            <span className="c-shop-list-content "><span className="d-block d-md-none c-shop-mobile-label">Qty:</span>{itemList.quantity}</span>

                                                                            <span className="c-shop-list-content c-order-details-price">
                                                                                <span className="d-block d-md-none c-shop-mobile-label">Your Price:</span>
                                                                                {itemList.price}
                                                                            </span>
                                                                            <span className="c-shop-list-content c-order-details-price">
                                                                                <span className="d-block d-md-none c-shop-mobile-label"><strong>Item Total:</strong></span>
                                                                                <strong>{itemList.itemTotal}</strong>
                                                                            </span>
                                                                        </div>
                                                                    </li>
                                                                </>
                                                                )
                                                            })}
                                                        </>
                                                        )
                                                    })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            : ""}
                        <div className="row c-delivery-meta  mt-4 py-4 border-top c-order-details-instruction">
                            <div className="col-md-8">
                                <div className="row">
                                    <div className="col-md-4">
                                        <label><strong>Additional Instructions:</strong></label>
                                        <p>Special shipping instructions or notes for your order (maximum 120 characters)</p>
                                    </div>
                                    <div className="col-md-8">
                                        <textarea value={props.isCSR ? productDetailsRef.current?.specialInstruction : orderDetailRef.current && orderDetailRef.current.specialInstruction} className="form-control c-text-area" id="specialInstMessageId" disabled="disabled" maxlength="120" style={props.isCSR ? { "background-color": "#fff", "height": "90px" } : { "background-color": "#e9ecef", "height": "90px" }}> </textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 my-4 my-md-0 c-delivery-meta-value text-start text-md-end">
                                <div className="row">
                                    <div className="col-6 col-md-8">
                                        <label>Items</label>
                                    </div>
                                    <div className="col-6 col-md-2 text-end">
                                        <p>{props.isCSR ? <>{productDetailsRef.current && productDetailsRef.current.items}</> : <>{orderDetailRef.current && orderDetailRef.current.items ? orderDetailRef.current.items : ""}</>}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6 col-md-8">
                                        <label>Freight & Handling</label>
                                    </div>
                                    <div className="col-6 col-md-2 text-end">
                                        <p>{props.isCSR ? <>{productDetailsRef.current && productDetailsRef.current.freightShipping}</> : <>{orderDetailRef.current && orderDetailRef.current.freightShipping ? orderDetailRef.current.freightShipping : ""}</>}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6 col-md-8">
                                        <label>
                                            Tax
                                        </label>
                                    </div>
                                    <div className="col-6 col-md-2 text-end">
                                        <p>{props.isCSR ? <>{productDetailsRef.current && productDetailsRef.current.tax}</> : <>{orderDetailRef.current && orderDetailRef.current.tax ? orderDetailRef.current.tax : ""}</>}</p>
                                    </div>
                                </div>
                                <hr />
                                {productDetailsRef.current?.discountAmount || orderDetailRef.current?.discountAmount ?
                                    <div class="row">
                                        <div class="col-6 col-md-8">
                                            <label>{props.isCSR ? <>{productDetailsRef.current && productDetailsRef.current.promotionDescription}</> : <>{orderDetailRef.current && orderDetailRef.current.promotionDescription ? orderDetailRef.current.promotionDescription : ""}</>}</label>
                                        </div>

                                        <div class="col-6 col-md-2 text-end">
                                            <p>- {props.isCSR ? <>{productDetailsRef.current?.discountAmount ? productDetailsRef.current.discountAmount : ''}</> : <>{orderDetailRef.current && orderDetailRef.current.discountAmount ? orderDetailRef.current.discountAmount : ""}</>}</p>
                                        </div>
                                    </div> : ''
                                }

                                <div className="row">
                                    <div className="col-6 col-md-8">
                                        <label>Total</label>
                                    </div>
                                    <div className="col-6 col-md-2 text-end">
                                        <p>{props.isCSR ? <>{productDetailsRef.current && productDetailsRef.current.orderTotal}</> : <>{orderDetailRef.current && orderDetailRef.current.orderTotal}</>}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        {props.isCSR && orderDetailsForCSRRef.current.isTempB2iUser ?
                            <>
                                {!isSubmittedOrderRef.current ?
                                    <>   {orderDetailsForCSRRef.current.orderState !== 'INCOMPLETE'
                                        ?
                                        <>
                                            {
                                                orderDetailsForCSRRef.current.orderState == 'SUBMITTED' || orderDetailsForCSRRef.current.orderState == 'REQUIRES_JDE_SYNC'
                                                    ?
                                                    <div className='form-submit text-end pt-3 pb-3'>
                                                        <button type="button" id="submittedButton" class="button button-big button-disabled order-submitted-btn" >SUBMITTED</button>
                                                    </div>
                                                    :
                                                    <>
                                                        {
                                                            orderDetailsForCSRRef.current.userType == 2 && !orderDetailsForCSRRef.current.orderOrgId
                                                                ?
                                                                <button className='btn btn-primary disabled' >Submit Order</button>
                                                                :
                                                                <div className='form-submit text-end pt-3 pb-3'>
                                                                    <button className='btn btn-primary' onClick={(event) => { handleSubmitOrder(event) }} >Submit Order</button>
                                                                </div>
                                                        }
                                                    </>

                                            }
                                        </>
                                        :
                                        <> </>
                                        // orderDetailsForCSRRef.current.orderState === 'INCOMPLETE' ? 
                                        //     <>

                                        //     </>
                                        //     :
                                        // <div className='text-end pt-3 pb-3'>
                                        //     <button id="submittedButton" class="button button-big button-disabled order-submitted-btn">SUBMITTED</button>
                                        // </div>

                                    }
                                    </>
                                    :
                                    <div className='text-end pt-3 pb-3'>
                                        <button type='button' id='submittedButton' className='button button-big button-disabled order-submitted-btn' >SUBMITTED</button>
                                    </div>
                                }
                            </> : <> </>}
                            {currentUrlRef.current == "checkout/order-detail" ? "":<>
                        {props.isCSR || userIdParamRef.current == null ? '' :
                            <div className="row my-2 my-md-2">
                                <div className="col-12 col-md-12 text-md-end text-center my-2 my-md-0 c-order-mobile-btn">
                                    <button type="button" className="btn btn-primary modal-link me-1" data-bs-toggle="modal" data-bs-dismiss="modal" onClick={handleClearErrMsg} data-bs-target="#newListModalww">
                                        Add to List
                                    </button>
                                    <button type="button" onClick={handleReorder} index="0" orderIdState={orderIdStateRef.current} id='orderIdState' className="btn btn-secondary" >
                                        Reorder
                                    </button>
                                </div>
                            </div>
                        }</>}


                        {/* reorder modal */}
                        {cartModal ?
                            <div className="modal gx-0 fade c-shopping-list-modal-body" id={`recorderModal${index}`} tabindex="-1" aria-labelledby={`recorderModal${index}`} aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                                    <div className="modal-content">
                                        <button type="button" className="btn-close" id={`recorderModal-close${index}`} data-bs-dismiss="modal" aria-label="Close"></button>
                                        <div className="modal-body">
                                            <form method="post" action="/" id="find-friend" className="col-12 form" data-hs-cf-bound="true">
                                                <div className="container-fluid list-modal-body">
                                                    <div className="row mb-4">
                                                        <div className="col-12">
                                                            <h3 className="modal-title mb-3" id="defaultModalLabel">Add to Cart</h3>
                                                            <p className="modal-subheading">You currently have items in your cart. Would you like to <strong>keep those items</strong> or <strong>replace your current cart</strong>?</p>
                                                        </div>
                                                        <div className="col-12 text-center">
                                                            <button type="button" className="btn btn-primary me-2" onClick={handleKeepExistingItem} index={index} action='keep'>Keep Existing Items</button>
                                                            <button type="button" className="btn btn-primary" onClick={handleKeepExistingItem} index={index} action='clearCart'>Replace Items</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""}

                        {/* Add to List modal */}
                        {
                            cartUpdatedModal &&
                            <Modal index={index} giftlistId={`giftlistId${index}`} props={orderItemDetailRef.current?.response?.validproducts} invalidProduct={orderItemDetailRef.current?.response?.invalidProducts} />

                        }

                    </div>


                    </>
                :
                <>
                    {props.isCSR ? <>{additionalInformationRef.current && <AdditionalInformation additionalInformation={additionalInformationRef.current} userId={replaceUserIdRef.current} showSubmitOrderError={showSubmitOrderErrorRef.current} />}</> : ''}
                </>
            }
       
        </div>

    );
}

export default OrderDetail;
